'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../../tslib.es6-130a177d.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var SvgProductSortBy = function (props) {
    var className = props.className;
    var svgProps = tslib_es6.__assign(tslib_es6.__assign({}, props), { className: '' });
    return (React__default['default'].createElement("div", { className: className },
        React__default['default'].createElement("svg", tslib_es6.__assign({ xmlns: "http://www.w3.org/2000/svg", width: "33", height: "22", viewBox: "0 15 40 10" }, svgProps),
            React__default['default'].createElement("g", { fill: "#323232", fillRule: "evenodd" },
                React__default['default'].createElement("path", { d: "M15.25 11l4.25 4.243-.707.705-3.044-3.048.001 14.104h-1l-.001-14.102-3.042 3.046-.707-.705L15.25 11zM24.75 29.004L29 24.762l-.707-.706-3.044 3.048L25.25 13h-1l-.001 14.102-3.042-3.046-.707.706 4.25 4.242z" })))));
};

exports.default = SvgProductSortBy;
//# sourceMappingURL=index.js.map
